export const validatePhoneVN = (phone?: string, translations?: any) => {
  if (!phone) {
    return translations?.['b2b.txt.requiredMsg'];
  }
  // const phoneRegex = /^(0|\+84)(3|5|7|8|9)[0-9]{8}$/;
  // if (!phoneRegex.test(phone)) {
  //   return translations?.['b2b.form.wrongPhoneFormat'];
  // }
  if (!/^\d{8,15}$/.test(phone)) {
    return translations?.['b2b.txt.phoneLengthInvalid'];
  }
  return '';
};
export const normalizePhoneInput = (value: string) => {
  return value.replace(/[^0-9+]/g, '');
};
export const validateField = (name: string, value: any, translations: any) => {
  switch (name) {
    case 'ticketNumber':
    case 'zone':
    case 'fullName':
      if (!value) return translations?.['b2b.txt.requiredMsg'];
      return '';
    case 'phoneNumber':
      return validatePhoneVN(value, translations);
    case 'childrenQuantity':
      if (value == null || Number.isNaN(value) || value < 0) {
        return translations?.['b2b.txt.requiredMsg'];
      }
      return '';
    // case 'customerNationality':
    //   if (value && value.length > 256) {
    //     return translations?.['b2b.txt.maxLength'];
    //   }
    //   return '';
    // case 'note':
    //   if (value && value.length > 256) {
    //     return translations?.['b2b.txt.maxLength'];
    //   }
    //   return '';
    default:
      return '';
  }
};
export const validateForm = (filter: any, translations: any) => {
  const errors: Record<string, string> = {};
  Object.keys(filter).forEach(key => {
    const message = validateField(key, filter[key], translations);
    if (message) errors[key] = message;
  });
  return errors;
};
